import { SVGProps } from "react";

const STIGojek = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Gojek" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} fill="#fff" rx="15%" /><path fill="#00AA13" d="M256 197a64 64 0 010 128 64 64 0 010-128M190 419a32 32 0 0025-59 107 107 0 1182 0 32 32 0 0025 59 171 171 0 10-132 0" /></svg>;

export { STIGojek };